module.exports = __webpack_public_path__ + "img/ionicons.621bd38.svg";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.svg?v=2.0.0
// module id = 1022
// module chunks = 14